import {defineCustomElement} from 'extensions/ui-utils';
import stylesheet from './x-capacity-flag.scss?as=stylesheet';
import {html, LitElement} from 'lit';
import {classMap} from 'lit/directives/class-map.js';

export class CapacityFlag extends LitElement {
	static get styles () {
		return [stylesheet];
	}

	static get properties () {
		return {
			size: {
				type: 'String'
			},
			type: {
				type: 'String'
			}
		};
	}

	constructor () {
		super();

		// Default values

		/**
		 * @type {''|'large'}
		 */
		this.size = '';

		/**
		 * @type {'cooling'|'heating'}
		 */
		this.type = '';
	}

	render () {
		const classes = {
			container: true,
			[this.type]: true,
			large: this.size === 'large'
		};

		return html`
			<div class="${classMap(classes)}">
				<span class="flag" aria-hidden="true">${this.type === 'cooling' ? 'C' : 'H'}</span>
				<div class="label">
					<slot></slot>KW
				</div>
			</div>
		`;
	}
};

defineCustomElement('x-capacity-flag', CapacityFlag);
